module.exports = __webpack_public_path__ + "static/media/U.306fb98b.jpg";